import React from 'react'

export default function WSVerifiedIcon() {
  return (
    <img
      css={{ height: 15, width: 13, position: 'relative', top: 1 }}
      src="https://ucarecdn.com/4bbbdf2f-f26a-4026-b210-c3fbd2d59b77/-/scale_crop/13x15/"
    />
  )
}
